<template>
  <require from="framework/html_behaviors/af-movable"></require>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="framework/aurelia_dialogs/dialog-styles.css"></require>

  <ux-dialog class="af-dialog --warning" af-movable.bind="header">
    <ux-dialog-header ref="header">
      Applicable Deviations
    </ux-dialog-header>
    <ux-dialog-body>
      <div class="af-dialog__icon d-none d-sm-none d-md-block"><i class="fas fa-clipboard-check"></i></div>
      <div class="af-dialog__main">
        <p>You have selected following non approved or approved by deviation airlines.</p>
        <p>Please make sure deviations are applicable to your travel.</p>
        <div style="width: 100%; height: 280px; overflow: auto; word-wrap: break-word;">
          <ul>
            <li repeat.for="airlineWarning of airlinesWarnings">
              ${airlineWarning.transportSegment.airlineName} (${airlineWarning.airlineStatusName})
              <div if.bind="airlineWarning.airlineApplicableDeviations.length > 0">
                <div class="pl-2" repeat.for="airlineApplicableDeviation of airlineWarning.airlineApplicableDeviations">
                  <a style="cursor: pointer;" click.delegate="showDeviationRequest(airlineApplicableDeviation)">${airlineApplicableDeviation.deviationType.name} Deviation ${airlineApplicableDeviation.validFrom | date} - ${airlineApplicableDeviation.validTo | date}</a>
                  <div class="pl-3" if.bind="airlineApplicableDeviation.deviationType.value === 1">${airlineApplicableDeviation.detail.originCity !== null ? airlineApplicableDeviation.detail.originCity.name : airlineApplicableDeviation.detail.originCityCustomName} (${airlineApplicableDeviation.detail.originCountry.name}) -> ${airlineApplicableDeviation.detail.destinationCity !== null ? airlineApplicableDeviation.detail.destinationCity.name : airlineApplicableDeviation.detail.destinationCityCustomName} (${airlineApplicableDeviation.detail.destinationCountry.name})</div>
                  <div class="pl-3" style="text-overflow: ellipsis; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;" title="${airlineApplicableDeviation.additionalInfo}">
                    <template repeat.for="line of airlineApplicableDeviation.additionalInfo.split('\n')">
                      ${line | sanitizeHTML}
                      <br if.bind="!$last" />
                    </template>
                  </div>
                </div>
              </div>
              <div class="pl-2" style="font-style: italic;" else>
                no applicable deviation found
              </div>
              <div class="pl-2">
                <a style="cursor: pointer;" click.delegate="createDeviationRequest(airlineWarning.transportSegment)">Create new</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ux-dialog-body>
    <ux-dialog-footer>
      <button type="button" click.delegate="ok()" attach-focus="true">Ok</button>
    </ux-dialog-footer>
  </ux-dialog>
</template>
